export const domainTranslations = {
  "Sites d'investigation": "Investigation Sites",
  "Documents d'etudes cliniques": "Clinical Study Documents",
  "Laboratoires d'analyses medicales": "Medical Analysis Laboratories",
  "Systemes informatises": "Computerized Systems",
  "Pharmacovigilance": "Pharmacovigilance",
  "Bonnes Pratiques Cliniques (BPC/GCP)": "Good Clinical Practice (GCP)",
  "Gestion des donnees cliniques": "Clinical Data Management",
  "Assurance qualite": "Quality Assurance",
  "Affaires reglementaires": "Regulatory Affairs",
  "Biostatistiques": "Biostatistics"
};

export const translateDomain = (domain, lang) => {
  if (lang === 'en' && domainTranslations[domain]) {
    return domainTranslations[domain];
  }
  return domain;
};

export const allDomainsTranslated = (lang) => {
  const domainsFr = [
    "Sites d'investigation",
    "Documents d'etudes cliniques",
    "Laboratoires d'analyses medicales",
    "Systemes informatises",
    "Pharmacovigilance",
    "Bonnes Pratiques Cliniques (BPC/GCP)",
    "Gestion des donnees cliniques",
    "Assurance qualite",
    "Affaires reglementaires",
    "Biostatistiques"
  ];
  
  if (lang === 'en') {
    return domainsFr.map(d => domainTranslations[d] || d);
  }
  return domainsFr;
};

// Nouvelle fonction pour convertir anglais -> français
export const toFrenchDomain = (domain) => {
  // Si c'est déjà en français, le retourner tel quel
  if (domainTranslations[domain]) {
    return domain;
  }
  
  // Sinon chercher la clé française qui a cette valeur anglaise
  for (const [fr, en] of Object.entries(domainTranslations)) {
    if (en === domain) {
      return fr;
    }
  }
  
  return domain; // Fallback si pas trouvé
};
